<script setup lang="ts">
import { IconCheck, IconChevronRight, IconPreloader } from '@/shared/ui/icons';

import type { DropdownMenuItem } from './types';

defineProps<{
  item: DropdownMenuItem;
  /** Подменю этого пункта открыто. */
  expanded?: boolean;
}>();
</script>

<template>
  <button
    type="button"
    class="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-(--text-primary) transition-colors duration-150 hover:bg-(--surface-hover)"
    :class="{
      'cursor-not-allowed opacity-50': item.disabled || item.loading,
      'bg-(--surface-hover)': expanded,
    }"
    :disabled="item.disabled || item.loading"
    :aria-haspopup="item.children ? 'menu' : undefined"
    :aria-expanded="item.children ? expanded : undefined"
    :aria-pressed="item.checked"
  >
    <span
      v-if="item.checked !== undefined"
      class="flex w-4 shrink-0 justify-center"
    >
      <IconCheck
        v-if="item.checked"
        :width="12"
        :height="10"
      />
    </span>
    <component
      :is="item.icon"
      v-if="item.icon && !item.loading"
      :width="16"
      :height="16"
    />
    <span>{{ item.label }}</span>
    <IconPreloader
      v-if="item.loading"
      class="ml-auto"
      :width="16"
      :height="16"
    />
    <IconChevronRight
      v-else-if="item.children"
      class="ml-auto text-(--text-secondary)"
      :width="12"
      :height="12"
    />
  </button>
</template>
